import { useSubscriptionFeature } from '#app/hooks/useSubscriptionFeature.js';

export const useHasNetworkAccess = (): {
  shouldShowFullNetworkUpgrade: boolean;
} => {
  const hasFullNetworkAccess = useSubscriptionFeature('CLIENT_ACCESS_NETWORK');

  return {
    shouldShowFullNetworkUpgrade: hasFullNetworkAccess === false,
  };
};
